export const data = {
  user: {
    isAnonymous: true,
  },
};
